import { HttpInterceptorFn } from '@angular/common/http'

import { environment } from '../../../../environments/environment'

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  // Clona a requisição e adiciona o header X-API-Key
  const cloned = req.clone({
    headers: req.headers.set('X-API-Key', environment.xApiKey),
  })

  return next(cloned)
}
